import styled from 'styled-components';

import { basicTransition } from '@dreryk/react-components';

export const StyledDisplayableLink = styled.a`
   ${basicTransition};
   text-decoration: none;
   color: ${(props) => props.theme.primary};

   &:hover {
      color: ${(props) => props.theme.primaryDark};
   }
`;

StyledDisplayableLink.displayName = 'StyledDisplayableLink';
